
<section
  :data-component-name="$options.name"
  class="row section-sansTheme section-page be_section mx-0"
  :class="[jel_getClassObject(content), content.sectionCoinRondTop ? 'be_coin_rond' : '']"
>
  <hr class="barre_entete" />
  <b-img-lazy
    v-if="imageEntete"
    :src="jel_getFichierSrc(imageEntete)"
    class="flex-shrink-0"
    :alt="content.title"
  />
  <h1 v-if="content.title" class="be_titre graphik_bold" :style="{ color: content.titleColor }">
    {{ content.title }}
  </h1>
  <p v-if="content.title2" class="be_sous_titre mt-lg-1">
    {{ content.title2 }}
  </p>
</section>
